import { render, staticRenderFns } from "./add-order.vue?vue&type=template&id=3afaaa5a&"
import script from "./add-order.vue?vue&type=script&lang=js&"
export * from "./add-order.vue?vue&type=script&lang=js&"
import style0 from "./add-order.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports